// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Filter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Filter = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Filter = _exports.Filter = function Filter(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_3580_36767)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0585938 3.99794C0.0585938 3.49587 0.465608 3.08887 0.967685 3.08887H19.1495C19.6516 3.08887 20.0586 3.49587 20.0586 3.99794C20.0586 4.5 19.6516 4.90701 19.1495 4.90701H0.967685C0.465608 4.90701 0.0585938 4.5 0.0585938 3.99794Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.08984 9.78944C3.08984 9.28738 3.49686 8.88037 3.99893 8.88037L16.1202 8.88037C16.6222 8.88037 17.0292 9.28738 17.0292 9.78944C17.0292 10.2915 16.6222 10.6985 16.1202 10.6985L3.99893 10.6985C3.49686 10.6985 3.08984 10.2915 3.08984 9.78944Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.12891 15.5805C7.12891 15.0784 7.53592 14.6714 8.038 14.6714L12.0784 14.6714C12.5805 14.6714 12.9875 15.0784 12.9875 15.5805C12.9875 16.0825 12.5805 16.4895 12.0784 16.4895L8.038 16.4895C7.53592 16.4895 7.12891 16.0825 7.12891 15.5805Z",
      fill: "#212B36"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_3580_36767"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "white"
    }))));
  };
});
